import { motion, useInView } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const BlogListing = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  //const [tab, setTab] = useState("all")
  const pblogdata = useStaticQuery(graphql/* GraphQL */ `
    query pblogQuery {
      allWpCategory(sort: { id: ASC }) {
        edges {
          node {
            id
            link
            name
            slug
          }
        }
      }
      allWpPost(sort: { date: DESC }) {
        nodes {
          title
          date(formatString: "DD MMM YYYY")
          excerpt
          uri
          featuredImage {
            node {
              mediaItemUrl
              altText
            }
          }
          categories {
            nodes {
              name
              slug
              id
            }
          }
        }
      }
    }
  `)
  const blogFixLimit = 100
  const blog_data = pblogdata.allWpPost.nodes
  const categories = pblogdata.allWpCategory.edges
  const [blogLimit, setBlogLimit] = useState(blogFixLimit)
  const [cBlogLimit, setCblogLimit] = useState(blogFixLimit)
  const [tabDetails, setTabDetails] = useState(blog_data.slice(0, blogFixLimit))

  const [tabOption, setTabOption] = useState("all")
  useEffect(() => {
    if (tabOption !== "all") {
      const data = []
      for (var i = 0; i < blog_data.length; i++) {
        for (var j = 0; j < blog_data[i].categories.nodes.length; j++) {
          if (blog_data[i].categories.nodes[j].name === tabOption) {
            data.push(blog_data[i])
          }
        }
      }
      setCblogLimit(data.length)
      setTabDetails(data.slice(0, blogLimit))
    } else {
      setCblogLimit(blog_data.length)
      setTabDetails(blog_data.slice(0, blogLimit))
    }
  }, [tabOption, blogLimit, blog_data])

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`blog py-100 xlscreen:py-80 mdscreen2:py-50 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          {blog_data.length > 0 && (
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="container-fluid-xl lg:!pr-80"
            >
              {blog_data.slice(0, 1).map((item, i) => (
                <Link key={i} to={item.uri}>
                  <div className="flex flex-wrap items-center">
                    <motion.div
                      variants={animFade}
                      className="lg:w-7/12 w-full"
                    >
                      {item?.featuredImage && (
                        <div className="border-bg-offwhite">
                          <div className="img relative">
                            <ImageOpt
                              imgData={item.featuredImage.node.mediaItemUrl}
                              imgAlt={item.featuredImage.node.title}
                              imgClass=""
                              width={2000}
                              height={1000}
                              imgLoad="lazy"
                            />
                          </div>
                        </div>
                      )}
                    </motion.div>
                    <div className="lg:w-5/12 w-full">
                      <div className="f-blog-content lg:pl-70 lg:max-w-[435px] lgscreen:pt-30">
                        <motion.div
                          variants={animFade}
                          className="preheading pb-15"
                        >
                            <span className="text-12 opacity-50 text-black">
                              {item.date}
                            </span>
                        </motion.div>
                        <motion.div
                          variants={animFade}
                          className="title title-grey uppercase"
                        >
                          <h3>{item.title}</h3>
                        </motion.div>
                        {item?.excerpt && (
                          <motion.div
                            variants={animFade}
                            className="content  pt-15"
                          >
                            {parse(item.excerpt)}
                          </motion.div>
                        )}
                        <motion.div
                          variants={animFade}
                          className="flex gap-40 xlscreen:gap-25 flex-wrap pt-30"
                        >
                          <Link
                            to={`${item.uri}`}
                            className="btn btn-grey"
                          >
                            read more
                          </Link>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </motion.div>
          )}

          <div className="blog-tabs pt-75 mdscreen2:pt-50">
            <div className="container-fluid-xl">
              <div className="common-tabs">
                <div className="tabs-main">
                  <motion.div
                    variants={animFade}
                    className="tab-link-wrapper overflow-x-auto w-full"
                  >
                    <ul className="flex items-center gap-x-25 tabs mdscreen:pt-15 mdscreen2:w-max mx-auto">
                      <li
                        onClick={() => setTabOption("all")}
                        className={`cursor-pointer text-black-100 border ${
                          tabOption === "all" ? "active-tab" : ""
                        }`}
                        onKeyDown={() => {
                          setTabOption("all")
                        }}
                        aria-hidden="true"
                      >
                        all
                      </li>
                      {categories
                        .filter(item => item.node.name !== "Uncategorized")
                        .map((item, j) => (
                          <li
                            key={j}
                            onClick={() => {
                              setTabOption(item.node.name)
                              setBlogLimit(blogFixLimit)
                            }}
                            className={`cursor-pointer text-black-100 border ${
                              tabOption === item.node.name ? "active-tab" : ""
                            }`}
                            onKeyDown={() => {
                              setTabOption(item.node.name)
                              setBlogLimit(blogFixLimit)
                            }}
                            aria-hidden="true"
                          >
                            {item.node.name}
                          </li>
                        ))}
                    </ul>
                  </motion.div>
                  <div className="tab-container pt-35 lgscreen:pt-25">
                    {tabDetails.length > 0 && (
                      <div className="tab-container-main">
                        <div className="grid grid-cols-3 mdscreen2:grid-cols-2 mdscreen:!grid-cols-1 gap-x-20 gap-y-80 lgscreen:gap-y-60 mdscreen2:gap-y-40">
                          {tabDetails.slice(1).map((item, l) => (
                            <Link
                              key={l}
                              to={`${item.uri}`}
                              className="h-full"
                            >
                              <div className="flex flex-col justify-between w-full h-full">
                                <div className="item_wrapper h-full w-full">
                                  {item?.featuredImage && (
                                    <motion.div variants={animFade}>
                                      <div className="img">
                                        <ImageOpt
                                          imgData={
                                            item.featuredImage.node.mediaItemUrl
                                          }
                                          imgAlt={item.featuredImage.node.title}
                                          imgClass=""
                                          width={2000}
                                          height={1000}
                                          imgLoad="lazy"
                                        />
                                      </div>
                                    </motion.div>
                                  )}
                                  <div className="pt-20 pl-10 pr-35 mdscreen2:!px-0">
                                    <motion.div
                                      variants={animFade}
                                      className="pre-heading"
                                    >
                                      <span className="text-black text-12 leading-16 text-opacity-50 font-400 !font-primary">
                                        {item.date}
                                      </span>
                                    </motion.div>
                                    <motion.div
                                      variants={animFade}
                                      className="title title-grey pt-15"
                                    >
                                      <h5 className="font-500 tracking-0.04em uppercase">
                                        {item.title}
                                      </h5>
                                    </motion.div>
                                    {item?.excerpt && (
                                      <motion.div
                                        variants={animFade}
                                        className="content pt-15 md:max-w-[320px]"
                                      >
                                        {parse(item.excerpt)}
                                      </motion.div>
                                    )}
                                  </div>
                                </div>
                                <motion.div
                                  variants={animFade}
                                  className="btn-custom pt-20 pl-10 pr-35 mdscreen2:!px-0"
                                >
                                  <span className="btn btn-grey">
                                    read more
                                  </span>
                                </motion.div>
                              </div>
                            </Link>
                          ))}
                        </div>

                        {blogLimit < blog_data.length &&
                          cBlogLimit !== tabDetails.length &&
                          tabDetails.length > 0 && (
                            <motion.div
                              variants={animFade}
                              className="btn-custom mt-130 xlscreen:mt-90 mdscreen:mt-70 flex justify-center items-center"
                            >
                              <button
                                onClick={() => {
                                  setBlogLimit(
                                    blogLimit => blogLimit + blogFixLimit
                                  )
                                }}
                                to={"#"}
                                className="btn btn-grey"
                              >
                                load more
                              </button>
                            </motion.div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </React.Fragment>
    )
  }
  return null
}

export default BlogListing
export const PageBlogListingFragment = graphql`
  fragment PageBlogListingFragment on WpPage_Pagecontent_PageContent_BlogListing {
    extraClass
    extraId
    hideSection
  }
`
